export default __webpack_public_path__ + "static/media/photo--sm--0.74a0ebe9.jpg";